import React from "react";
import { useNavigate } from "react-router-dom";
import "./Start_Btn.css";

const Start_Btn = ({
  text,
  link,
  onClick,
  className = "",
  type = "button",
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      type={type}
      className={`start_btn ${className}`}
      onClick={handleClick}
    >
      {text}
    </button>
  );
};

export default Start_Btn;
